import React from "react";
import IndiaMap from "./StockStatics/Map.jsx";
import StockAge from "./StockStatics/StockAge.jsx";
import { StockLobWise } from "./StockStatics/StockLobWise.jsx";
import { StockCombined } from "./StockStatics/StockCombined.js";
import { StockKpi } from "./StockKpi";

const Stock = () => {
  return (
    <div className="flex flex-col flex-grow  w-full">
      <div className="px-2 mt-1">
        <StockKpi />
      </div>
      <section className="md:grid grid-cols-3 gap-3 mx-2 mt-2 sm:block">
        <div className="lg:block md:grid md:grid-cols-[2fr_auto_1fr]">
          <div className="bg-white rounded-md">
            <StockAge />
          </div>
          <div className="bg-white rounded-md  mt-[12px]">
            <StockCombined />
          </div>
        </div>
        <div className="lg:block md:grid md:grid-cols-[2fr_auto_1fr] bg-white rounded-md md:h-full h-[332px] relative mt-2 md:mt-0">
          <IndiaMap />
        </div>
        <div className="bg-white rounded-md lg:block md:grid md:grid-cols-[2fr_auto_1fr] mt-2 md:mt-0">
          <StockLobWise />
        </div>
      </section>
    </div>
  );
};

export default Stock;
